/*******************
@purpose : Redux Action Types
@Author : INIC
******************/

// UI reducer types
export const SET_UI_KEY = "SET_UI_KEY";
export const SHOW_ALERT = "SHOW_ALERT";
export const REMOVE_ALERT = "REMOVE_ALERT";
export const TOGGLE_MODAL = "TOGGLE_MODAL";
export const TOGGLE_LOADER = "TOGGLE_LOADER";
export const BUTTON_LOADER = "BUTTON_LOADER";
export const TOGGLE_PROFILE = "TOGGLE_PROFILE";
export const SHOW_DOCUMENT_HIDE_PROFILE = "SHOW_DOCUMENT_HIDE_PROFILE";
export const SHOW_EDIT_PROFILE_HIDE_SHOW_PROFILE =
  "SHOW_EDIT_PROFILE_HIDE_SHOW_PROFILE";
export const SHOW_PAYMENT_HIDE_SHOW_PROFILE = "SHOW_PAYMENT_HIDE_SHOW_PROFILE";
export const SHOW_SUCESSS_POPUP = "SHOW_SUCESSS_POPUP";
export const SET_ACTIVE_TAB = "SET_ACTIVE_TAB";
export const SET_SHOW_OTP_BLOCK = "SET_SHOW_OTP_BLOCK";
// Auth reducer types
export const SET_TOKEN = "SET_TOKEN";
export const REMOVE_TOKEN = "REMOVE_TOKEN";
export const SET_LOGOUT = "SET_LOGOUT";

// User reducer types
export const SET_USER_INFO = "SET_USER_INFO";
export const SET_DOCUMENTS = "SET_DOCUMENTS";
export const SET_TRIPS = "SET_TRIPS";
// Home reducer types
export const SET_HOME_INFO = "SET_HOME_INFO";
export const SET_SHOW_MENU = "SET_SHOW_MENU";

// brand reducer types
export const SET_BRAND_BANNER_INFO = "SET_BRAND_BANNER_INFO";
export const SET_BRAND_VEHICLE_DATA = "SET_BRAND_VEHICLE_DATA";
export const SET_BRAND_VEHICLE_META_DATA = "SET_BRAND_VEHICLE_META_DATA";
export const SET_BRAND_VEHICLE_LIST = "SET_BRAND_VEHICLE_LIST";
export const SET_BRAND_VEHICLE_LIST_CLEAR = "SET_BRAND_VEHICLE_LIST_CLEAR";
export const SET_FILTER_PRICE_ACTION = "SET_FILTER_PRICE_ACTION";
export const SET_BRAND_VEHICLE_TOTAL_RECORD = "SET_BRAND_VEHICLE_TOTAL_RECORD";

// category reducer types
export const SET_CATEGORY_BANNER_INFO = "SET_CATEGORY_BANNER_INFO";
export const SET_CATEGORY_VEHICLE_DATA = "SET_CATEGORY_VEHICLE_DATA";
export const SET_VEHICLE_LIST_BY_BRAND = "SET_VEHICLE_LIST_BY_BRAND";

// common reducer types
export const SET_BRAND_LIST = "SET_BRAND_LIST";
export const SET_CATEGORY_LIST = "SET_CATEGORY_LIST";
export const SET_CURRENT_LOCATION = "SET_CURRENT_LOCATION";
export const SET_ADDRESS_INFO = "SET_ADDRESS_INFO";
export const SET_LOCATION_INFO = "SET_LOCATION_INFO";
export const SET_LOCATION_INFO_FOR_MAINTENANCE =
  "SET_LOCATION_INFO_FOR_MAINTENANCE";
export const SET_CURRENT_PAGE = "SET_CURRENT_PAGE";
export const SET_DYNAMIC_PAGE_LIST = "SET_DYNAMIC_PAGE_LIST";
export const SET_SLUGS = "SET_SLUGS";
export const SET_FEATURES = "SET_FEATURES";
export const SET_META_DATA = "SET_META_DATA";
export const SET_VEHICLE_LIST_CLEAR = "SET_VEHICLE_LIST_CLEAR";
export const SET_VEHICLE_LIST = "SET_VEHICLE_LIST";
export const SET_VEHICLE_META_DATA = "SET_VEHICLE_META_DATA";
export const SET_VEHICLE_TOTAL_RECORD = "SET_VEHICLE_TOTAL_RECORD";
export const SET_CMS_LIST = "SET_CMS_LIST";
export const SET_COUNTRIES_LIST = "SET_COUNTRIES_LIST";
export const SET_STATES_LIST = "SET_STATES_LIST";
export const SET_CITIES_LIST = "SET_CITIES_LIST";
export const UPDATE_FILTER_CLICK_COUNT = "UPDATE_FILTER_CLICK_COUNT";
export const UPDATE_SHARE_CLICK_COUNT = "UPDATE_SHARE_CLICK_COUNT";
export const SET_SELECTED_PAGE = "SET_SELECTED_PAGE";
export const SET_SELECTED_SLUG = "SET_SELECTED_SLUG";
export const ADD_REMOVE_BRAND_CATEGORY_SLUG = "ADD_REMOVE_BRAND_CATEGORY_SLUG";
export const ADD_REMOVE_COLOR = "ADD_REMOVE_COLOR";
export const ADD_REMOVE_SEAT = "ADD_REMOVE_SEAT";
export const ADD_REMOVE_PRICE = "ADD_REMOVE_PRICE";
export const CLEAR_CATEGORY_BRAND_COLOR_SEAT_PRICE =
  "CLEAR_CATEGORY_BRAND_COLOR_SEAT_PRICE";

// blog reducer
export const SET_BLOG_LIST_CLEAR = "SET_BLOG_LIST_CLEAR";
export const SET_BLOG_LIST = "SET_BLOG_LIST";
export const SET_BLOG_META_DATA = "SET_BLOG_META_DATA";
export const SET_BLOG_TOTAL_RECORD = "SET_BLOG_TOTAL_RECORD";

//card reducer data
export const SET_CREDITE_CARD_DETAIL = "SET_CREDITE_CARD_DETAIL";

//reservation
export const SET_RESERVATION_DETAILS = "SET_RESERVATION_DETAILS";
export const SET_IS_FORM_VALID = "SET_IS_FORM_VALID";
export const SET_DISTANCE_MILES_DETAILS = "SET_DISTANCE_MILES_DETAILS";

//sitemap reducer
export const SET_SITEMAP_DETAIL = "SET_SITEMAP_DETAIL";

// trips reducer
export const SET_PAST_TRIPS = "SET_PAST_TRIPS";
export const SET_CURRENT_TRIPS = "SET_CURRENT_TRIPS";
export const SET_FUTURE_TRIPS = "SET_FUTURE_TRIPS";

export const CLEAR_PAST_TRIPS = "CLEAR_PAST_TRIPS";
export const CLEAR_CURRENT_TRIPS = "CLEAR_CURRENT_TRIPS";
export const CLEAR_FUTURE_TRIPS = "CLEAR_FUTURE_TRIPS";

//user Favorite
export const USER_FAVORITE_DATA = "USER_FAVORITE_DATA";
export const CLEAR_USER_FAVORITE_DATA = "CLEAR_USER_FAVORITE_DATA";

// vehicle drive now
export const SET_VEHICLE_AVAILABLE_FOR_DRIVE_NOW =
  "SET_VEHICLE_AVAILABLE_FOR_DRIVE_NOW";
export const RESET_VEHICLE_AVAILABLE_FOR_DRIVE_NOW =
  "RESET_VEHICLE_AVAILABLE_FOR_DRIVE_NOW";
export const SET_VEHICLE_DATA = "SET_VEHICLE_DATA";
export const SET_VEHICLE_AVAILABLE_SLOT = "SET_VEHICLE_AVAILABLE_SLOT";
